var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-shrink-0 w-8 h-8 font-medium flex items-center justify-center type-scale-n5 cursor-pointer relative select-none",class:_vm.classes,on:{"click":_vm.onClick}},[_c('span',{class:!this.schedule && 'opacity-25'},[_vm._v(_vm._s(_vm.day.dayOfMonth))])])
}
var staticRenderFns = []

export { render, staticRenderFns }